import normalize from "jsonapi-normalizer";
import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { AdminProfileInfo } from "../../../api/typings/Profiles";
import { getUpdateProfileData } from "../../serializers/usersProfilesAdminsSerializer";
import { ProfilesAdminsApi } from "../../../api/users/ProfilesAdminsApi";

export class ProfileAdminService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = async (data: AdminProfileInfo) => {
    const updateProfileData = await getUpdateProfileData(data);
    const response = await ProfilesAdminsApi.updateAdminProfile(data.id!, updateProfileData);
    const { users_profiles_admins } = normalize(response).entities;
    this.ctx.usersProfilesAdmins = { ...this.ctx.usersProfilesAdmins, ...users_profiles_admins };
  };
}
